import { useEffect } from 'react';
import { useQuery } from 'wasp/client/operations';
import { getPlatformTheme } from 'wasp/client/operations';
import useColorMode from '../hooks/useColorMode';
import { applyPlatformTheme, clearThemeVariableOverrides } from './applyTheme';
import type { PlatformThemeConfig } from '../../shared/theme/platformTheme';

type ThemeProviderProps = {
  children: React.ReactNode;
};

export default function ThemeProvider({ children }: ThemeProviderProps) {
  const [colorMode] = useColorMode();
  const { data, isLoading } = useQuery(getPlatformTheme);

  useEffect(() => {
    if (isLoading) {
      return;
    }

    const theme = (data?.theme ?? null) as PlatformThemeConfig | null;
    const mode = colorMode === 'dark' ? 'dark' : 'light';

    if (theme) {
      applyPlatformTheme(theme, mode);
    } else {
      clearThemeVariableOverrides();
    }
  }, [data, colorMode, isLoading]);

  return <>{children}</>;
}
